import Axios, { type AxiosError, type AxiosRequestConfig } from 'axios';
import queryString from 'query-string';

import { getCookie } from './getCookie';

export const AXIOS_INSTANCE = Axios.create();

const EXCLUDED_PATHS = ['/accounts/auth/', '/report/', '/inspect/'];

// Helper function to check if current path includes any of the excluded paths
const isExcludedPath = () => EXCLUDED_PATHS.some((path) => window.location.pathname.includes(path));

AXIOS_INSTANCE.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401 && !isExcludedPath()) {
      window.location.href = `/accounts/auth/sign-in/?next=${window.location.pathname}`;
    }
    return Promise.reject(error);
  }
);

AXIOS_INSTANCE.defaults.paramsSerializer = {
  serialize(params) {
    return queryString.stringify(params, { arrayFormat: 'none' });
  },
};

export const customAxios = <T>(config: AxiosRequestConfig, options?: AxiosRequestConfig): Promise<T> => {
  const source = Axios.CancelToken.source();
  const promise = AXIOS_INSTANCE({
    ...config,
    ...options,
    cancelToken: source.token,
    headers: {
      ...config.headers,
      'X-CSRFToken': getCookie('csrftoken'), // use your own cookie getter here or environment variable
    },
    timeout: 0,
  }).then(({ data }) => data);

  // @ts-expect-error cancel is not part of the promise
  promise.cancel = () => {
    source.cancel('Query was cancelled');
  };

  return promise;
};

// In some case with react-query and swr you want to be able to override the return error type so you can also do it here like this
export type ErrorType<Error> = AxiosError<Error>;

export type BodyType<BodyData> = BodyData;
